import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { IconComponent, chevronRight, cross, provideIcons, tick } from '../../../../shared/icons';
import { AlpitranslatePipe } from '../../../../core/pipes/alpitranslate.pipe';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlpitranslatePipe, IconComponent],
  providers: [
    provideIcons({
      tick,
      cross,
      chevronRight
    })
  ]
})
export class ToggleComponent {
  @Input() state: boolean;
  @Input() showButton: boolean;
  @Output() changedState = new EventEmitter<boolean>();
  constructor(private cdr: ChangeDetectorRef) {}

  toggle() {
    this.state = !this.state;
    this.changedState.emit(this.state);
    this.cdr.markForCheck();
  }
}
